import React from "react";
import { useAuth } from "../contexts/AuthContext";
import ChatInterface from "./ChatInterface";
import AuthOverlay from "./AuthOverlay";
import { Bot } from "lucide-react";

const MainLayout: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl flex items-center justify-center shadow-lg animate-pulse">
            <Bot className="w-8 h-8 text-white" />
          </div>
          <p className="text-gray-600 dark:text-neutral-400 text-sm animate-pulse">
            Loading your workspace...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative min-h-screen">
      {/* Always render the main interface for the beautiful background */}
      <ChatInterface />

      {/* Show auth overlay if not authenticated */}
      {!isAuthenticated && <AuthOverlay />}
    </div>
  );
};

export default MainLayout;
